<template>
  <StatisticsForm />
</template>

<script>
import StatisticsForm from '@/components/statistics/allStatistics/StatisticsForm.vue';

  export default {
    components: {
      StatisticsForm
    }
  }
</script>

<style lang="scss" scoped>

</style>